import React from "react";
import "../App.css";
function Features() {
  return (
    <section className="py-5 bg-light my-5">
      <div className="container">
        
        {/* Heading */}
        <div className="text-center mb-5">
          <h2 className="fw-bold">Powerful Features</h2>
          <p className="text-muted">
            Everything you need to manage school supplies efficiently
          </p>
        </div>

        <div className="row g-4">

          {/* Card 1 */}
          <div className="col-md-6 col-lg-4">
            <div className="card feature-card h-100 text-center p-4 shadow-sm border-0">
              <div className="card-body">
                <i className="fa-solid fa-shield-halved feature-icon"></i>
                <h5 className="mt-3 fw-bold">Secure & Private</h5>
                <p className="text-muted">
                  Unique access codes ensure only authorized parents can view and purchase.
                </p>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="col-md-6 col-lg-4">
            <div className="card feature-card h-100 text-center p-4 shadow-sm border-0">
              <div className="card-body">
                <i className="fa-solid fa-shirt feature-icon"></i>
                <h5 className="mt-3 fw-bold">Uniform Management</h5>
                <p className="text-muted">
                  Complete size charts, stock tracking, and seasonal collections.
                </p>
              </div>
            </div>
          </div>

          {/* Card 3 */}
          <div className="col-md-6 col-lg-4">
            <div className="card feature-card h-100 text-center p-4 shadow-sm border-0">
              <div className="card-body">
                <i className="fa-solid fa-book feature-icon"></i>
                <h5 className="mt-3 fw-bold">Study Materials</h5>
                <p className="text-muted">
                  Organize textbooks, lab kits, and digital resources easily.
                </p>
              </div>
            </div>
          </div>

          {/* Card 4 (Added) */}
          <div className="col-md-6 col-lg-4">
            <div className="card feature-card h-100 text-center p-4 shadow-sm border-0">
              <div className="card-body">
                <i className="fa-solid fa-truck-fast feature-icon"></i>
                <h5 className="mt-3 fw-bold">Quick Delivery</h5>
                <p className="text-muted">
                  Efficient logistics to ensure supplies reach on time before sessions.
                </p>
              </div>
            </div>
          </div>

          {/* Card 5 */}
          <div className="col-md-6 col-lg-4">
            <div className="card feature-card h-100 text-center p-4 shadow-sm border-0">
              <div className="card-body">
                <i className="fa-solid fa-chart-line feature-icon"></i>
                <h5 className="mt-3 fw-bold">Analytics</h5>
                <p className="text-muted">
                  Track orders, revenue, and performance in real-time.
                </p>
              </div>
            </div>
          </div>

          {/* Card 6 */}
          <div className="col-md-6 col-lg-4">
            <div className="card feature-card h-100 text-center p-4 shadow-sm border-0">
              <div className="card-body">
                <i className="fa-solid fa-headset feature-icon"></i>
                <h5 className="mt-3 fw-bold">24/7 Support</h5>
                <p className="text-muted">
                  Dedicated support team to assist schools and parents.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Features;